import { render, staticRenderFns } from "./excellentvideodisplay.vue?vue&type=template&id=d276fa74&scoped=true&"
import script from "./excellentvideodisplay.vue?vue&type=script&lang=js&"
export * from "./excellentvideodisplay.vue?vue&type=script&lang=js&"
import style0 from "./excellentvideodisplay.vue?vue&type=style&index=0&id=d276fa74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d276fa74",
  null
  
)

export default component.exports